import React from 'react';
import Styles from './styles';
import { useVideoPlayer } from '../../../../hooks/useVideoPlayer';
import { secondsToTime } from '../../../../../../utils/dateUtils';

const { Container } = Styles;

export const Time: React.FC = () => {
  const { currentTime, maskedDuration } = useVideoPlayer();
  return (
    <Container>
      {secondsToTime(currentTime)} / {secondsToTime(maskedDuration)}
    </Container>
  );
};
